import { useMemo } from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { scorePassword, type PasswordStrengthLevel } from '@/lib/auth-schema';

interface PasswordStrengthProps {
  password: string;
  className?: string;
}

const LEVEL_LABEL: Record<PasswordStrengthLevel, string> = {
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
};

const LEVEL_BAR_CLASS: Record<PasswordStrengthLevel, string> = {
  weak: '[&>div]:bg-destructive',
  medium: '[&>div]:bg-amber-500',
  strong: '[&>div]:bg-emerald-500',
};

const LEVEL_TEXT_CLASS: Record<PasswordStrengthLevel, string> = {
  weak: 'text-destructive',
  medium: 'text-amber-600',
  strong: 'text-emerald-600',
};

export function PasswordStrength({ password, className }: PasswordStrengthProps) {
  const { score, level } = useMemo(() => scorePassword(password), [password]);

  if (!password) return null;

  const value = (score / 5) * 100;

  return (
    <div className={cn('space-y-1', className)} aria-live="polite">
      <Progress
        value={value}
        className={cn('h-2', LEVEL_BAR_CLASS[level])}
        aria-label={`Fortaleza de la contraseña: ${LEVEL_LABEL[level]}`}
      />
      <p className={cn('text-xs font-medium', LEVEL_TEXT_CLASS[level])}>
        Fortaleza: {LEVEL_LABEL[level]}
      </p>
    </div>
  );
}

export default PasswordStrength;
